import React, { useContext } from 'react';
import classNames from 'classnames';
import { CloseOutlined as MenuIconOpen } from 'jl-design-system/components/icons/CloseOutlined';
import { MenuOutlined as MenuIconClosed } from 'jl-design-system/components/icons/MenuOutlined';

import { AccountLinks } from '../account-links/AccountLinks';
import { WishList } from '../wishlist/Wishlist';
import { Basket } from '../basket/Basket';
import { EnvVarsFeaturesContext } from '../../scaffold/EnvVarsFeaturesContext';

import styles from './user-tools.scss';
import { StoreFinderIcon } from '../store-finder-icon/StoreFinderIcon';
import { isVariant } from '../../utils/monetate/getVariantData';
interface UserToolsProps {
  isMenuOpen: boolean;
  onMenuButtonClick: (event: React.MouseEvent<HTMLAnchorElement>) => void;
  isTypeaheadOpen?: boolean;
}

export const UserTools = ({
  isMenuOpen,
  onMenuButtonClick,
  isTypeaheadOpen = false,
}: UserToolsProps) => {
  const { features, showWishListIconIsActive } = useContext(
    EnvVarsFeaturesContext
  ) as EnvVarsFeaturesContextValue;

  const shouldHideBasket = features.mvoMode || features.hideBasketIcon;
  const shouldHideWishList = features.mvoMode || features.hideWishListIcon;

  const showWishListIcon =
    showWishListIconIsActive && !isVariant('C', showWishListIconIsActive);
  const showStoreFinderIcon = !showWishListIcon;

  return (
    <nav
      data-testid="user-tools-nav"
      className={classNames(styles.nav, {
        [styles.hidden]: isTypeaheadOpen,
      })}
    >
      <ul className={styles.navList}>
        {showStoreFinderIcon && (
          <li className={styles.hideOnLg} key="store-finder">
            <StoreFinderIcon />
          </li>
        )}

        <AccountLinks lgOnlyClassname={styles.lgOnly} />

        {!shouldHideWishList && (
          <li
            className={classNames({
              [styles.lgOnly]: !showWishListIcon,
            })}
            key="wishlist"
          >
            <WishList />
          </li>
        )}

        {!shouldHideBasket && (
          <li key="basket">
            <Basket />
          </li>
        )}

        <li className={styles.hideOnLg} data-testid="menu-icon" key="menu-icon">
          <a
            id="mobile-menu-toggle"
            href="/menu"
            data-testid="nav-link--menu"
            onClick={onMenuButtonClick}
            role="button"
            aria-label={isMenuOpen ? 'Close Menu' : 'Open Menu'}
            aria-expanded={isMenuOpen}
            aria-controls="main-navigation-menu"
          >
            <span className={styles.visuallyHidden}>
              {isMenuOpen ? 'Close' : 'Menu'}
            </span>

            {isMenuOpen ? (
              <MenuIconOpen
                className={styles.icon}
                dataTestId="nav-menu-close-icon"
                size="large"
                title="Close Menu"
              />
            ) : (
              <MenuIconClosed
                className={styles.icon}
                dataTestId="nav-menu-icon"
                size="large"
                title="Open Menu"
              />
            )}
          </a>
        </li>
      </ul>
    </nav>
  );
};
